import React, { createContext, useContext, useState } from 'react'

const UIContext = createContext()

export const UIProvider = ({ children }) => {
  const [showAuth, setShowAuth] = useState(false)
  const [showListPG, setShowListPG] = useState(false)
  const [showOwnerAlert, setShowOwnerAlert] = useState(false) // ← Add this

  return (
    <UIContext.Provider value={{ 
      showAuth, setShowAuth, 
      showListPG, setShowListPG,
      showOwnerAlert, setShowOwnerAlert // ← Add this
    }}>
      {children}
    </UIContext.Provider>
  )
}

export const useUI = () => useContext(UIContext)